export const name_general = `^[a-zA-Z0-9_'%\\(\\) ,:;.?"\\-\\[\\]\\/]+$`;